// Pure pricing helpers — extracted from modules/Pricing.jsx so the rate math
// and copy can be unit-tested without a DOM. Must stay in sync with
// backend/src/services/computeCredit.js TIER_TABLE + COMPUTE_CREDIT_*_RATE_LIST.

// Per-tier compute rates (USD per run). A "credit" = $1 of prepaid compute.
export const RATES = {
  payg: { cpu: 0.8, gpu: 3.0, monthly: 0 },
  analyst: { cpu: 0.56, gpu: 2.1, monthly: 50 },
  pro: { cpu: 0.48, gpu: 1.8, monthly: 120 },
};

/** How many CPU runs a credit balance funds at a tier's rate (integer). */
export function cpuRunsForCredits(creditsUsd, tier = 'payg') {
  const rate = RATES[tier]?.cpu || RATES.payg.cpu;
  if (rate <= 0) return 0;
  return Math.floor(creditsUsd / rate);
}

/** Percent the tier's CPU rate saves vs PAYG (e.g. 30 for analyst). */
export function cpuSavingsPct(tier = 'payg') {
  const base = RATES.payg.cpu;
  const t = RATES[tier];
  if (!t || base <= 0) return 0;
  return Math.round((1 - t.cpu / base) * 100);
}

/** Human label for a monthly plan: "$50 credits included (≈ 89 CPU runs)". */
export function planCreditLabel(tier, monthlyCredits) {
  const runs = cpuRunsForCredits(monthlyCredits, tier);
  return `${monthlyCredits} credits included (≈ ${runs} CPU runs)`;
}

/** Top-up card line: "$20 one-time · ≈ 41 CPU runs at your rate". */
export function topupRunLabel(creditsUsd, priceUsd, tier = 'payg') {
  const runs = cpuRunsForCredits(creditsUsd, tier);
  return `$${priceUsd} one-time · ≈ ${runs} CPU runs at your rate`;
}
